<template>
  <b-card>
    <create-debtor
      class="mt-2 pt-75"
    />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import CreateDebtor from './CreateDebtor.vue'

export default {
  components: {
    BCard,
    CreateDebtor,
  },
}
</script>
